import React, { useEffect } from "react";
import { Button, Textarea } from "../../Components/StyledComponents";
import './Setting.scss';
import axios from "axios";
import { alertRef } from "../../App";
import Modal from "../../Components/Modal/Modal";
import ReceiptPreview from "./ReceiptPreview";

const ReceiptSetting = () => {
    const [ text, setText ] = React.useState('')//적립 영수증 문구
    const [ tempText, setTempText ] = React.useState('');//적립 영수증 문구 임시 저장
    const [ isTextModify, setIsTextModify ] = React.useState(false)//적립 영수증 문구 수정 여부

    const modalRef = React.useRef(null)//미리 보기 모달 Ref
    useEffect(() => {
        getText()
    },[])

    //적립 영수증 문구 Get
    const getText = () => {
        axios.get('/api/receipt/text')
        .then((data) => {
            setText(data.data.CustomText)
        })
    }

    //적립 영수증 문구 수정
    const patchText = () => {
        axios.patch('/api/receipt/text',{ CustomText : text })
        .then((data) => {
            alertRef.current.showAlert({ title : `저장되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
    }

    //적립 영수증 문구 임시 저장 및 복구
    const toggleText = () => {
        if( isTextModify){
            setText(tempText)
        }else {
            setTempText(text)
        }
        setIsTextModify(old => !old)
    }

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>적립 영수증 설정</p>
            </div>
            
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>적립 영수증 문구</p>
                        <p className='info-sub-title'>적립 영수증에 표시될 매장 안내사항이나 소개 등을 적어주세요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => toggleText()}>
                            { isTextModify ? '취소하기' : '수정하기'}
                        </Button>
                        {
                            isTextModify && 
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => {setIsTextModify(old => !old); patchText() }}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className='header-divider' ></div>

                <Textarea
                    disabled={!isTextModify}
                    value={text}
                    onChange={(e) => setText(e.target.value)} 
                    style={{ width : '100%', height : 80 }}
                    placeholder='예) 주문해주셔서 감사합니다!'
                />
                
                <div className="row" style={{ alignItems : 'flex-end', justifyContent : 'flex-end', marginTop : 12}}>
                    <Button variant='main' small style={{ width : 88, alignSelf : 'flex-end' }} onClick={() => {modalRef.current.openModal()}}>
                        미리보기
                    </Button>
                </div>
            </div>

            {/* 영수증 미리보기 모달 */}
            <Modal ref={modalRef} contentContainer={{ width : 500, backgroundColor : '#ebebeb' }} isHeader title="적립 영수증 미리보기">
                <ReceiptPreview intro={ text }/>
            </Modal>
        </div>
    )
}

export default ReceiptSetting